<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><a id="pg3">Contents</a></p><a id="pg3">
</a><p class="toc"><a id="pg3"></a><a href="#/Acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter01">1. Establishment of Seneca County and Its Towns</a></p>
<p class="toc"><a href="#/Chapter02">2. The Official County Seal for Seneca County, New York</a></p>
<p class="toc"><a href="#/Chapter03">3. The New York State College of Agriculture at Ovid (Willard)</a></p>
<p class="toc"><span href="#/Chapter04" title="Link target outside of Sample">4. Automobiles in Seneca County: Early History</span></p>
<p class="toc"><span href="#/Chapter05" title="Link target outside of Sample">5. Uncovering the History of the Backbone Ridge</span></p>
<p class="toc"><span href="#/Chapter06" title="Link target outside of Sample">6. A History of Cayuga Lake Park</span></p>
<p class="toc"><span href="#/Chapter07" title="Link target outside of Sample">7. Cobblestone Buildings</span></p>
<p class="toc"><span href="#/Chapter08" title="Link target outside of Sample">8. William Watts Folwell</span></p>
<p class="toc"><span href="#/Chapter09" title="Link target outside of Sample">9. Brook Farm Barn</span></p>
<p class="toc"><span href="#/Chapter10" title="Link target outside of Sample">10. Ku Klux Klan Activity Near Waterloo and Geneva in the 1920s</span></p>
<p class="toc"><span href="#/Chapter11" title="Link target outside of Sample">11. The Kingdom</span></p>
<p class="toc"><span href="#/Chapter12" title="Link target outside of Sample">12. The Murder of John Walters and the Execution of Charles Johnson</span></p>
<p class="toc"><span href="#/Chapter13" title="Link target outside of Sample">13. Degory Prowtt</span></p>
<p class="toc"><span href="#/Chapter14" title="Link target outside of Sample">14. The Three Bears in Ovid</span></p>
<p class="toc"><span href="#/Chapter15" title="Link target outside of Sample">15. The Waterloo Organ Company</span></p>
<p class="toc"><span href="#/Chapter16" title="Link target outside of Sample">16. A Tale of a Whale or, a Whale of a Tale</span></p>
<p class="toc"><a id="pg4"></a><span href="#/Chapter17" title="Link target outside of Sample">17. The Windmill</span></p>
<p class="toc"><span href="#/Chapter18" title="Link target outside of Sample">18. Ezra Sutton and the First Home Run in Major League Baseball</span></p>
<p class="toc"><span href="#/Chapter19" title="Link target outside of Sample">19. The Black Diamond</span></p>
<p class="toc"><span href="#/Chapter20" title="Link target outside of Sample">20. The Trial of Rhoda Bement</span></p>
<p class="toc1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?41c13394